<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <div style="display: flex;margin-top: 10px">
      <el-select v-model="company" style="width: 150px;height: 35px;" @change="getSoftwareDataList">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="year" style="width: 150px;height: 35px;margin-left: 10px" @change="getSoftwareDataList">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <div class="dimension_amount" :style="amountStyle" @click="getDimensionAmountInfo()">
        金额($)
      </div>
      <div class="dimension_sales" :style="salesStyle" @click="getDimensionSalesInfo()">
        销量(套)
      </div>
    </div>
<!--------------------------------------------显示设定-------------------------------------------------------->
    <div style="margin-top: 20px" v-for ="(item,index) in softwareDataList">
      <div style="display:flex;">
        <div style="width: 200px;font-size: 16px;"><b>{{ index + 1 }}. &nbsp;&nbsp;{{ item.softwareName }}：</b></div>
        <el-popover
            placement="right"
            :width="300"
            trigger="hover"
        >
          <!-- 弹出框内容 -->
          <div style="max-width: 300px;max-height: 200px;overflow: auto;">
            <el-checkbox-group v-model="item.showProductNameList">
              <el-checkbox style="display: block;margin-right: 0;width:250px;line-height: 32px;"
                           v-for="product in item.productNameList"
                           :value="product"
                           :label="product"
              >
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <!-- 悬浮按钮的插槽内容 -->
          <template #reference>
            <el-button>显示/隐藏</el-button>
          </template>
        </el-popover>
      </div>


      <div style="margin-top: 10px;background-color: #eeeeee">
        <div style="display: flex;text-align: center;line-height: 35px;font-weight: bold;font-size: 15px">
          <div style="flex: 1;">产品</div>
          <div style="width: 150px" v-if="showDollar">目标($)</div>
          <div style="width: 150px" v-else>目标(套)</div>
          <div style="width: 150px;" v-if="showDollar">实际($)</div>
          <div style="width: 150px;" v-else>实际(套)</div>
          <div style="width: 150px" v-if="showDollar">缺口($)</div>
          <div style="width: 150px" v-else>缺口(套)</div>
          <div style="width: 50px;border-right: 1px solid #a19e9e" v-for="item in 12">{{ item }}</div>
          <div style="width: 100px">YTD进度</div>
          <div style="width: 100px">年度进度</div>
        </div>
        <div v-for="data in item.dataList" style="display: flex;margin-top: 5px;line-height: 30px;text-align: center;">
          <template v-if="(item.showProductNameList).includes(data.productName)">
          <div style="flex: 1;text-align: right;">{{ data.productName }}</div>
          <div style="width: 150px" v-if="showDollar" >{{ data.targetAmount }}</div>
          <div style="width: 150px" v-else >{{ data.targetSales }}</div>
          <div style="width: 150px;" v-if="showDollar" >{{ data.actualAmount }}</div>
          <div style="width: 150px;" v-else >{{ data.actualSales }}</div>
          <div style="width: 150px;" v-if="showDollar" >{{ data.gapAmount }}</div>
          <div style="width: 150px;" v-else >{{ data.gapSales }}</div>
          <div style="width: 600px;position: relative;">
            <el-progress style="position: absolute; top: 50%; transform: translateY(-50%);" :style="getDateStyle()"
                         :show-text="false" color="#ccc" :stroke-width="15" :percentage="100"/>
            <el-progress style="position: absolute; top: 50%; transform: translateY(-50%);" :style="getStyle(data)"
                         :text-inside="true" :stroke-width="15" :percentage="100" :format="format(data)"  :color="getColors(data)"/>
            <div style="position:absolute;top: 0;left: 0;width: 100%;height: 100%;display: flex">
              <div v-for="n in 12" style="flex: 1;border-right: 1px solid #a19e9e;"></div>
            </div>
          </div>
          <div style="width: 100px" v-if="showDollar" >{{ data.ytdAmount }}</div>
          <div style="width: 100px" v-else >{{ data.ytd }}</div>
          <div style="width: 100px" v-if="showDollar" >{{ data.annualAmount + '%' }} </div>
          <div style="width: 100px" v-else >{{ data.annual + '%' }}</div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import dayjs from 'dayjs';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import dayOfYear from 'dayjs/plugin/dayOfYear';

dayjs.extend(isLeapYear);
dayjs.extend(dayOfYear);
export default {
  name: "DsTask",

  data() {
    return {
      companyList:[],
      company:'summaryData',
      yearPercentage:0,
      year:'',
      amountStyle:'',
      salesStyle:'',
      showDollar:true,
      softwareDataList:[],
      yearList:[]

    }
  },

  created() {
    this.calculateCurrentDate();
    this.getYearList();
    this.getCompanyList();
    this.getDimensionAmountInfo();
    this.getSoftwareDataList();

  },
  methods:{

    async getSoftwareDataList(){
      let params = {year:this.year,company:this.company};
      let data = await this.$http('crmDsTaskService.getSoftwareData',params);
      if(data.length > 0){
        this.softwareDataList = [];
        this.softwareDataList = data;
        for (let item of this.softwareDataList){
          this.loadingProductName(item);
        }
      }else {
        this.softwareDataList = [];
      }
      await this.calculateCurrentDate();
    },

    //加载产品名称
    loadingProductName(item){
      let list = item.dataList;
      if(!list){
        return;
      }
      item.productNameList = [];
      item.showProductNameList = [];
      for (let obj of list){
        if(obj.productName){
          item.productNameList.push(obj.productName);
          item.showProductNameList.push(obj.productName);
        }
      }

    },
    async getYearList(){
      const now = dayjs();
      this.year = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },
    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      data.unshift({value:'summaryData',label:'汇总数据'})
      this.companyList = data;
    },
    //计算今天在全年的进度
    calculateCurrentDate(){
      const now = dayjs();
      let year = now.year();
      if(year > parseInt(this.year)){
        this.yearPercentage = 100;
        return;
      }
      const startOfYear = now.startOf('year');
      const endOfYear = now.endOf('year');
      // 计算当前年的天数
      const daysInYear = endOfYear.diff(startOfYear, 'day') + 1;
      // 计算今天是今年的第几天
      const dayOfYear = now.dayOfYear();
      // 计算百分比
      this.yearPercentage = ((dayOfYear / daysInYear) * 100).toFixed(2);
    },

    getColors(item){
      let annual;
      if(this.showDollar){
        annual = item.annualAmount;
      }else {
        annual = item.annual;
      }
      let colors = '';
      if(annual < 25){
        colors = '#f56c6c';
      }
      if(annual >= 25 && item.annual < 70){
        colors = '#e6a23c';
      }
      if(annual >= 70 && item.annual < 90) {
        colors = '#1989fa';
      }
      if(annual >= 90){
        colors = '#5cb87a';
      }
      return colors;
    },
    format(item){
      return () => {
        if(this.showDollar){
          return item.annualAmount + '%';
        }else {
          return item.annual + '%';
        }
      }
    },


    getDateStyle(){
      let style = '';
      style = 'width:' + this.yearPercentage + '%;';
      return style;
    },
    getStyle(item){
      let style = '';
      let annual ;
      if(this.showDollar){
        annual = item.annualAmount;
      }else {
        annual = item.annual;
      }
      if(annual > 100){
        annual = 100;
      }
      style = 'width:' + annual + '%;';
      return style;

    },
    getDimensionAmountInfo(){
      //先改渲染状态
      if(this.salesStyle){
        this.salesStyle = '';
      }
      this.amountStyle = 'background: rgb(4,134,254);color:white';
      //显示金额
      this.showDollar = true;

    },
    getDimensionSalesInfo(){
      //先改渲染状态
      if(this.amountStyle){
        this.amountStyle = '';
      }
      this.salesStyle = 'background: rgb(4,134,254);color:white';
      //显示套数
      this.showDollar = false;
    }

  }
}
</script>

<style scoped>

.dimension_amount{
  width: 150px;
  line-height: 30px;
  margin-left: 20px;
  border: 1px #cccccc solid;
  text-align: center;
  cursor: pointer
}

.dimension_sales{
  width: 150px;
  line-height: 30px;
  border: 1px #cccccc solid;
  border-left: none;
  text-align: center;
  cursor: pointer
}


</style>